export const formatWashroomAnswers = (answers: any) => {
  const data: any = {};

  const taps = answers.basin_tap_count?.groups || [];

  data.taps = {};

  taps.forEach((tap, index) => {
    data.taps[`tap_${index}`] = {
      ...(tap.tap_leak && {
        leak: tap.tap_leak,
      }),

      ...(tap.tap_type && {
        type: tap.tap_type,
      }),

      ...(tap.tap_leak_flow && {
        flowrate: tap.tap_leak_flow,
      }),
    };
  });

  const toilets = answers.toilet_count?.groups || [];

  data.toilets = {};

  toilets.forEach((toilet, index) => {
    data.toilets[`toilet_${index}`] = {
      ...(toilet.toilet_type && {
        type: toilet.toilet_type,
      }),

      ...(toilet.toilet_leak_flow && {
        leak: toilet.toilet_leak_flow,
      }),
    };
  });

  const urinals = answers.urinal_count?.groups || [];

  data.urinals = {};

  urinals.forEach((urinal, index) => {
    data.urinals[`urinal_${index}`] = {
      ...(urinal.urinal_type && {
        type: urinal.urinal_type,
      }),

      ...(urinal.urinal_leak_flow && {
        leak: urinal.urinal_leak_flow,
      }),
    };
  });

  const showers = answers.shower_count?.groups || [];

  data.showers = {};

  showers.forEach((shower, index) => {
    data.showers[`shower_${index}`] = {
      ...(shower.shower_type && {
        type: shower.shower_type,
      }),

      ...(shower.shower_leak && {
        leak: shower.shower_leak,
      }),

      ...(shower.shower_control && {
        control: shower.shower_control,
      }),
    };

    if (shower.showers_per_week) {
      data.showers_per_week = Number(shower.showers_per_week);
    }
  });

  return data;
};
